import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideDeleteBatchModal } from './deleteBatchModal';

export const DELETE_BATCH_REQUEST = 'DELETE_BATCH_REQUEST';
export const DELETE_BATCH_SUCCESS = 'DELETE_BATCH_SUCCESS';
export const DELETE_BATCH_FAILURE = 'DELETE_BATCH_FAILURE';

function requestDeleteBatch() {
  return {
    type: DELETE_BATCH_REQUEST,
    isDeletingBatch: true
  };
}

function receiveDeleteBatch(deleteBatchResponse) {
  return {
    type: DELETE_BATCH_SUCCESS,
    isDeletingBatch: false,
    deleteBatchResponse
  };
}

function rejectDeleteBatch() {
  return {
    type: DELETE_BATCH_FAILURE,
    isDeletingBatch: false
  };
}

export function deleteBatch(batchId, batchDisplayId, refreshAction) {
  return (dispatch) => {
    dispatch(requestDeleteBatch(batchId));

    const promise = () => ApiService
      .deleteBatch(batchId)
      .then((response) => {
        dispatch(receiveDeleteBatch(response.data));
        if (refreshAction.length === 2) {
          dispatch(refreshAction[0](...refreshAction[1]));
        }
        toastr.success('', `The batch '${ batchDisplayId || '' }' was successfully deleted`);
        return dispatch(hideDeleteBatchModal());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteBatch, true));
        }
      });
    return promise();
  };
}
